import React from "react";
import { useEffect, useState } from "react";
import ReusableForm from "../../../components/ReusableTable/ReusableForm/ReusableForm";
import { type } from "@testing-library/user-event/dist/type";
import { postData } from "../../../services/NodeServices";
import { toast } from "react-toastify";

export default function CategoryEdit({ mode }) {
  let mydata = false;
  const storedData = sessionStorage.getItem("edit-category");
  if (storedData) {
    mydata = JSON.parse(storedData);
    console.log("Received Data:", mydata);
  }

  let data = [
    {
      name: "productcategoryname",
      type: "text",
      value: mode == "edit" ? (mydata ? mydata.productcategoryname : "") : "",
    },
  ];

  const submitApi = async (data) => {
   

    try {
      if (mode == "edit") {
       

        const result = await postData("api/productcategory/edit", {'productcategoryname':data.productcategoryname,'productcategoryid':mydata.productcategoryid});
        mydata["productcategoryname"] = data.productcategoryname;

        if (result.status) {
          console.log(result);
          toast.success("data edited");
        }
      } else {
        let body = {
          productcategoryname: data.productcategoryname,
        };

        const result = await postData("api/productcategory/add", body);

        if (result.status) {
          console.log(result);
          toast.success("data edited");
        }
      }
    } catch {}
  };

  return <ReusableForm data={data} submitApi={submitApi} />;
}
